import { z } from 'zod';
import { LANGUAGES } from './roles';

export const languageSchema = z.enum(LANGUAGES);

export const telegramAuthSchema = z.object({
  initData: z.string().min(1).max(4096),
  /** Set when the Mini App was opened from an agent invite link (start_param). */
  startParam: z.string().max(64).optional(),
});
export type TelegramAuthInput = z.infer<typeof telegramAuthSchema>;

export const updateLanguageSchema = z.object({
  language: languageSchema,
});

export const updateSettingSchema = z.object({
  value: z.unknown(),
});

/** Agent codes look like AG-4821; invite start params look like ag_4821. */
export const AGENT_CODE_REGEX = /^AG-[0-9A-Z]{4,8}$/;
export const AGENT_START_PARAM_REGEX = /^ag_([0-9A-Za-z]{4,8})$/;

export function agentCodeFromStartParam(startParam?: string | null): string | null {
  if (!startParam) return null;
  const m = AGENT_START_PARAM_REGEX.exec(startParam);
  return m ? `AG-${m[1].toUpperCase()}` : null;
}
